import { services } from '../services';
var action = "report/commission";

export const commissionService = {
    getCommission,
    getCommissionAvailable
};



function getCommission(object = {}) {
    return services.restApi(`${action}`, 'POST', object);
}
function getCommissionAvailable(object = {}) {
    return services.restApi(`${action}/available`, 'POST', object);
}
